import {createSelector} from 'reselect'
import {State} from 'lib/store'
import {RouterState} from 'connected-react-router'

const selectRouterFeature = (state: State): RouterState => state.router

export const getLocation = createSelector(selectRouterFeature, router => router.location)
